import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { toast } from 'react-toastify';

import _ from 'lodash';

import { format } from 'date-fns';
import * as Yup from 'yup';
import $ from 'jquery';
import { v4 } from 'uuid';
import {
  collection,
  doc,
  getDocs,
  query,
  setDoc,
  updateDoc,
  writeBatch,
  where,
  getDoc,
} from 'firebase/firestore';

import { DB, Realtime, Storage } from '~/services/firebase';

// import { usePayments } from '../../hooks/payments';
// import api from '../../services/api';
// import { API_URL_ORDER } from '../../services/api/routes';

import getAddressFormatted from '~/utils/getAddressFormatted';
import IAddress from '~/interfaces/IAddress';
import { useAuth } from '~/hooks/auth';
import ICartProduct from '~/interfaces/ICartProduct';
import IOrder from '~/interfaces/IOrder';
import getCurrencyFormatted from '~/utils/getCurrencyFormatted';
import IReport from '~/interfaces/IReport';
import getValidationErrors from '~/utils/getValidationErrors';
import { useToast } from '~/hooks/toast';
import getPrintBluetoothV1 from '~/utils/getPrintBluetooth';
import 'jquery-mask-plugin/dist/jquery.mask.min';
import { useOrders } from '~/hooks/orders';
import { useClients } from '~/hooks/clients';
import IClient from '~/interfaces/IClient';
import { bff } from '~/services/bff';
import IProduct from '~/interfaces/IProduct';
import {
  Container,
  Overlay,
  Header,
  SubHeader,
  Table,
  Resume,
  TableContainer,
  SelectContainer,
  Error,
  InputContainer,
  AddressText,
  AddressButton,
  Payments,
} from './styles';
import { useCartCompany } from '../../../../hooks/cartCompany';
import ISupplie from '~/interfaces/ISupplie';
import { useProductsCompany } from '~/hooks/productsCompany';
import { useSupplies } from '~/hooks/supplies';
import getPrintBluetooth from '~/utils/getPrintBluetooth-v2';
import getEncondingPrinter from '~/utils/getEncodingPrinter';
import getPrintHTML from '~/utils/getPrintHTML';
import { SelectDeliveryman } from '~/components/SelectDeliveryman';
import { Link } from 'react-router-dom';

const { REACT_APP_POS_SIMPLE_ADDRESS, REACT_APP_FIREBASE_PROJECT } =
  process.env;

interface DataProps {
  name: string;
  whatsapp: string;
  payment: string;
  money_change: string;
  sell_on_credit_date: string;
}

interface OrderPayment {
  payment_method_id: string;
  value: number;
  value2?: number;
  value_formatted: string;
}

interface SupplieData {
  uid: string;
  quantity: number;
}

const OrderConfirm: React.FC = () => {
  const {
    products,
    setShowConfirmOrder,
    setShowOrderAddress,
    discountValue,
    orderAddress,
    clear,
    setOpenModalCart,
    orderAddressText,
    additionValue,
    setOrderAddress,
    setOrderAddressText,
  } = useCartCompany();
  const { addToast } = useToast();
  const { setOpenPos } = useOrders();
  const { selectedClient } = useClients();
  const { products: allProducts } = useProductsCompany();
  const { clearContext } = useSupplies();

  // const { payments } = usePayments();
  // const { appDomain } = useSettings();
  // const { orderAddress, deliveryType, setOrderAddress } = useDistances();

  const { company, user } = useAuth();

  const [yearMonth] = useState(format(new Date(), 'yyyy-MM'));
  const [day] = useState(format(new Date(), 'dd'));
  const [errors, setErrors] = useState('');
  const [data, setData] = useState({} as DataProps);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({} as any);
  const [deliverymanId, setDeliverymanId] = useState('');

  const [payment, setPayment] = useState('');
  const [client, setClient] = useState<null | IClient>(null);

  // const [payments, setPayments] = useState([] as PaymentDTO[]);

  const [orderPayments, setOrderPayments] = useState<OrderPayment[]>([]);

  useEffect(() => {
    setData(old => ({
      ...old,
      name: selectedClient.name,
      whatsapp: selectedClient.whatsapp,
    }));
  }, [selectedClient]);

  useEffect(() => {
    async function loadClient() {
      const q = query(
        collection(DB, 'clients'),
        where('whatsapp', '==', data.whatsapp),
      );

      const querySnapshot = await getDocs(q);

      if (querySnapshot.docs.length > 0) {
        const aux = querySnapshot.docs[0].data() as IClient;
        setClient({
          ...aux,
          uid: querySnapshot.docs[0].id,
        });
        setData(old => ({
          ...old,
          name: aux.name,
        }));
      }
    }

    if (data.whatsapp && data.whatsapp.length === 15) {
      loadClient();
    }
  }, [user, data.whatsapp]);

  const subtotal = useMemo(() => {
    let sum = 0;

    products.forEach(item => {
      sum += item.quantity * parseFloat(item.value);
    });

    return sum;
  }, [products]);

  const fidelitAlert = useMemo(() => {
    if (company.fidelit && company.fidelit_min_value) {
      if (subtotal < company.fidelit_min_value) {
        return {
          message: `Atenção! Essa compra não contará como fidelidade, pois o valor é inferior ao mínimo de ${getCurrencyFormatted(
            company.fidelit_min_value,
          )}.`,
          value: true,
        };
      }
    }

    return {
      message: '',
      value: false,
    };
  }, [company, subtotal]);

  const fidelitDiscount = useMemo(() => {
    if (
      !company.fidelit ||
      !company.fidelit_quantity ||
      !client?.fidelit_order_quantity ||
      fidelitAlert.value
    )
      return 0;

    return (client.fidelit_order_quantity || 0) >= company.fidelit_quantity
      ? client.fidelit_balance || 0
      : 0;
  }, [client, company, fidelitAlert]);

  const paymentIsMoney = useMemo(() => {
    let isMoney = false;

    orderPayments.forEach(item => {
      if (item.payment_method_id === '0') isMoney = true;
    });

    return isMoney;
  }, [orderPayments]);

  const paymentIsSellCredit = useMemo(() => {
    let isSellCredit = false;

    orderPayments.forEach(item => {
      if (item.payment_method_id === '4') isSellCredit = true;
    });

    return isSellCredit;
  }, [orderPayments]);

  // const moneyChange = useMemo(() => {
  //   let totalInMoney = 0;

  //   const paymentMoney = payments.find(
  //     (item: any) => item.name.toLowerCase().trim() === 'dinheiro',
  //   );

  //   if (paymentMoney) {
  //     orderPayments.forEach(item => {
  //       if (item.payment_method_id === paymentMoney.id)
  //         totalInMoney += item.value;
  //     });
  //   }

  //   return parseFloat(`${data.money_change || 0}`) - totalInMoney;
  // }, [data, orderPayments, payments]);

  const datetime = useMemo(() => {
    const now = new Date();

    return format(now, "dd/MM/yyyy 'às' HH:mm");
  }, []);

  const addCardValue = useMemo(() => {
    let sum = 0;
    let isPaymentCreditCard = false;
    let isPaymentDebitCard = false;

    orderPayments.forEach(item => {
      if (item.payment_method_id === '2') {
        // credito
        if (company.add_card && company.add_card > 0) {
          if (company.add_card_type === '1') {
            const addCard = (item.value * company.add_card) / 100;
            sum += addCard;
          } else {
            isPaymentCreditCard = true;
          }
        }
      }

      // debito
      if (item.payment_method_id === '1') {
        if (company.add_card2_type === '1') {
          const addCard = (item.value * company.add_card2) / 100;
          sum += addCard;
        } else {
          isPaymentDebitCard = true;
        }
      }
    });

    if (isPaymentCreditCard) sum += company.add_card;
    if (isPaymentDebitCard) sum += company.add_card2;

    // if (company.add_card && company.add_card > 0) {
    //   if (company.add_card_type === '1') {
    //     orderPayments.forEach(item => {
    //       if (item.payment_method_id === '2') {
    //         const addCard = (item.value * company.add_card) / 100;
    //         sum += addCard;
    //       }
    //     });
    //   } else {
    //     let isPaymentCreditCard = false;
    //     orderPayments.forEach(item => {
    //       if (item.payment_method_id === '2') isPaymentCreditCard = true;
    //     });

    //     if (isPaymentCreditCard) sum += company.add_card;
    //   }
    // }

    return sum;
  }, [company, orderPayments]);

  const total = useMemo(() => {
    const shippingCost = orderAddress.distance
      ? orderAddress.distance.value
      : 0;

    return (
      subtotal + shippingCost + additionValue - discountValue - fidelitDiscount
    );
  }, [orderAddress, subtotal, discountValue, additionValue, fidelitDiscount]);

  useEffect(() => {
    if (total > 0) {
      setOrderPayments([
        {
          payment_method_id: '',
          value: total,
          value_formatted: getCurrencyFormatted(total),
        },
      ]);
    }
  }, [total]);

  const addNewPaymentMethod = useCallback(() => {
    let sum = 0;

    orderPayments.forEach(item => {
      sum += item.value;
    });

    const remaining = total - sum;

    setOrderPayments(value => [
      ...value,
      {
        payment_method_id: '',
        value: remaining,
        value_formatted: getCurrencyFormatted(remaining),
      },
    ]);

    setTimeout(() => {
      ($('.money') as any).mask('#.##0,00', { reverse: true });
    }, 100);
  }, [orderPayments, total]);

  const disableButton = useMemo(() => {
    let sum = 0;

    orderPayments.forEach(item => (sum += item.value));

    return sum < total || loading;
  }, [orderPayments, total, loading]);

  const parseProducts = useMemo(() => {
    const tmp: ICartProduct[] = [];

    products.forEach(item => {
      let _total = 0;

      item.complements.forEach(element => {
        _total += element.quantity * parseFloat(element.item.value);
      });

      tmp.push({
        ...item,
        value: `${parseFloat(item.value) + _total}`,
        image: item.image || '',
      });
    });

    return tmp;
  }, [products]);

  const alterAddress = useCallback(() => {
    setShowConfirmOrder(false);
    setShowOrderAddress(true);
  }, [setShowOrderAddress, setShowConfirmOrder]);

  const getSuppliesUpdated = useCallback(async () => {
    const q = query(
      collection(DB, 'supplies'),
      where('company_id', '==', company.uid),
    );
    const querySnapshot = await getDocs(q);

    const items = [] as ISupplie[];

    querySnapshot.docs.forEach(item => {
      const parseItem = {
        ...item.data(),
        uid: item.id,
      } as ISupplie;

      items.push(parseItem);
    });

    return items;
  }, [company.uid]);

  const getProductsUpdated = useCallback(async (): Promise<IProduct[]> => {
    try {
      await bff.delete(`/products/${REACT_APP_FIREBASE_PROJECT}`);
      const response = await bff.get(`/products/${REACT_APP_FIREBASE_PROJECT}`);
      await bff.delete(`/products/${REACT_APP_FIREBASE_PROJECT}`);
      return response.data;
    } catch (err) {
      console.log(err);
      return [];
    }
  }, []);

  const updateInvetoryOfSUpplies = useCallback(async () => {
    const batch = writeBatch(DB);
    const suppliesUpdateds = await getSuppliesUpdated();

    parseProducts.map((pd: ICartProduct) => {
      const find = allProducts.find(item => item.uid === pd.uid);

      if (find && find.supplies && find.supplies.length > 0) {
        find.supplies.forEach((supplieFind: any) => {
          const supplie = suppliesUpdateds.find(
            item => item.uid === supplieFind.uid,
          );

          if (supplie) {
            const stock =
              parseFloat(`${supplie.stock}`) -
              parseFloat(`${pd.quantity}`) * parseFloat(supplieFind.quantity);

            console.log('stock', stock);
            const supplieRef = doc(DB, 'supplies', supplie.uid);
            batch.update(supplieRef, {
              stock,
            });
          }
        });
      }
    });

    await batch.commit();
  }, [allProducts, getSuppliesUpdated, parseProducts]);

  const updateInventoryOfProductsSold = useCallback(async () => {
    const batch = writeBatch(DB);
    const productsUpdateds = await getProductsUpdated();

    parseProducts.forEach(product => {
      const find = productsUpdateds.find(item => item.uid === product.uid);

      if (find && find.stok) {
        console.log('subtrai stok');
        const productRef = doc(DB, 'products', find.uid);
        batch.update(productRef, { stok: find.stok - product.quantity });
      }
    });

    await batch.commit();
  }, [parseProducts, getProductsUpdated]);

  const notify = useCallback(
    (name: string, orderTotal: number, order_id: string) => {
      const notification = {
        type: '0',
        description: `Novo pedido criado, no valor de ${getCurrencyFormatted(
          orderTotal,
        )}`,
        link: `/orders/details/${order_id}`,
        company_id: company.uid,
        user_id: company.user_id,
        created_at: new Date(),
      };

      const notificationsRef = Realtime.ref(`notifications/${company.user_id}`);
      const newNotificationRef = notificationsRef.push();
      newNotificationRef.set(notification);
    },
    [company],
  );

  const orderStatusRealtime = useCallback(
    (order_id: string) => {
      const orderStatus = {
        order_id,
        status: '0',
      };

      const ref = Realtime.ref(`orders/${user.uid}`);
      const newNotificationRef = ref.push();
      newNotificationRef.set(orderStatus);
    },
    [user],
  );

  const updateReport = useCallback(async () => {
    const companiesRef = collection(DB, 'reports');
    const q = query(companiesRef, where('company_id', '==', company.uid));
    const querySnapshot = await getDocs(q);

    if (!querySnapshot.empty) {
      const item = {
        ...querySnapshot.docs[0].data(),
        uid: querySnapshot.docs[0].id,
      } as IReport;

      let orders_quantity = 1;
      let sales_total = 0;

      if (item.data[yearMonth] && item.data[yearMonth][day]) {
        orders_quantity += item.data[yearMonth][day].orders_quantity;
        sales_total += item.data[yearMonth][day].sales_total;
      }

      await updateDoc(doc(DB, 'reports', item.uid), {
        [`data.${yearMonth}.${day}`]: {
          orders_quantity,
          sales_total,
        },
      });
    }
  }, [company, yearMonth, day]);

  const updateCustomer = useCallback(
    async (value: number, address: any) => {
      if (selectedClient.uid) {
        const docSnap = await getDoc(doc(DB, 'clients', selectedClient.uid));
        const item = docSnap.data() as IClient;
        const client = {
          ...item,
          uid: selectedClient.uid,
        } as IClient;

        if (client.buy_on_credit >= 0) client.buy_on_credit += value;
        if (!client.buy_on_credit) client.buy_on_credit = value;

        // incrementar contador de pedidos do cliente
        client.order_count = (client.order_count || 0) + 1;

        await updateDoc(doc(DB, 'clients', selectedClient.uid), {
          ...client,
        });
      }
    },
    [selectedClient],
  );

  const handleSubmit = useCallback(async () => {
    try {
      if (paymentIsSellCredit && !data.sell_on_credit_date) {
        setError({
          sell_on_credit_date: true,
        });
        return;
      }

      let hasPaymentMethod = true;
      orderPayments.forEach(item => {
        if (!item.payment_method_id) hasPaymentMethod = false;
      });

      if (!hasPaymentMethod) {
        setError({
          paymentMethod: true,
        });
        return;
      }

      setError({});

      setLoading(true);

      const uid = v4();
      const code = `${uid.substr(0, 3)}${uid.substr(uid.length - 3, 3)}`;

      let address: any = {};
      if (orderAddress.road) address = orderAddress;
      if (orderAddressText) address = orderAddressText;

      // Buscar dados do cliente para obter o order_count atual
      let currentOrderCount = 0;
      if (selectedClient.uid) {
        const docSnap = await getDoc(doc(DB, 'clients', selectedClient.uid));
        const clientData = docSnap.data() as IClient;
        currentOrderCount = clientData.order_count || 0;
      }

      const parseData: any = {
        ...data,
        products: parseProducts,
        client_id: selectedClient.uid || '',
        shippingCost: orderAddress.distance?.value
          ? orderAddress.distance?.value
          : 0,
        subtotal,
        total: total + addCardValue,
        additionValue,
        address,
        company_id: company.uid,
        company_name: company.fantasy,
        company_user_id: company.user_id,
        created_at: new Date(),
        code,
        status: '0',
        pix_file: '',
        order_type: orderAddress.road || orderAddressText ? '1' : '0',
        name: data.name ? data.name : 'ATENDIMENTO BALCÃO',
        whatsapp: data.whatsapp ? data.whatsapp : '(99) 99999-9999',
        orderPayments: orderPayments.map(item => ({
          ...item,
          value: item.value2 ? item.value2 : item.value,
        })),
        paymentMethod: payment || '',
        thing: data.money_change || '',
        deliverymen: deliverymanId,
        uid,
        fidelitDiscount,
        client_order_count: currentOrderCount + 1,
      };

      const schema = Yup.object().shape({
        name: Yup.string().required('O campo nome é obrigatório'),
        whatsapp: Yup.string().required('O campo whatsapp é obrigatório'),
        // paymentMethod: Yup.string().required(
        //   'O campo forma de pagamento é obrigatório',
        // ),
      });

      await schema.validate(parseData, {
        abortEarly: false,
      });

      await setDoc(doc(DB, 'orders', uid), parseData);
      await updateCustomer(paymentIsSellCredit ? parseData.total : 0, address);
      await updateInventoryOfProductsSold();
      await updateInvetoryOfSUpplies();
      await bff.delete(`/orders/${REACT_APP_FIREBASE_PROJECT}`);

      if (
        company.fidelit &&
        company.fidelit_value &&
        company.fidelit_quantity &&
        !fidelitAlert.value &&
        client
      ) {
        if (
          client.fidelit_order_quantity &&
          client.fidelit_order_quantity >= company.fidelit_quantity
        ) {
          await updateDoc(doc(DB, 'clients', client.uid), {
            fidelit_balance: 0,
            fidelit_order_quantity: 0,
          });
        } else {
          await updateDoc(doc(DB, 'clients', client.uid), {
            fidelit_balance:
              (client.fidelit_balance || 0) + (company.fidelit_value || 0),
            fidelit_order_quantity: (client.fidelit_order_quantity || 0) + 1,
          });
        }
      }

      notify(parseData.name, parseData.total, uid);
      orderStatusRealtime(uid);
      updateReport();
      clear();
      clearContext();

      addToast({
        type: 'success',
        description: 'Pedido realizado com sucesso.',
      });

      setOrderAddressText('');
      setOrderAddress({} as IAddress);
      setShowConfirmOrder(false);
      setOpenModalCart(false);
      setOpenPos(false);

      // history.push(`/${company.app_domain}/orders${search}`);

      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
      // alert(JSON.stringify(err));
      if (err instanceof Yup.ValidationError) {
        const parseErrors = getValidationErrors(err);
        console.log(parseErrors);
        // setErrors(parseErrors);
      }
    }
  }, [
    setOrderAddressText,
    setOrderAddress,
    data,
    parseProducts,
    setShowConfirmOrder,
    setOpenPos,
    setOpenModalCart,
    updateInventoryOfProductsSold,
    subtotal,
    clear,
    total,
    company,
    notify,
    orderStatusRealtime,
    orderAddress,
    updateReport,
    addToast,
    orderAddressText,
    selectedClient,
    payment,
    updateCustomer,
    additionValue,
    paymentIsSellCredit,
    orderPayments,
    addCardValue,
    updateInvetoryOfSUpplies,
    clearContext,
    deliverymanId,
    client,
    fidelitDiscount,
    fidelitAlert,
  ]);

  // const handleSubmit = useCallback(async () => {
  //   try {
  //     setError('');
  //     setLoading(true);

  //     let parseData = {
  //       whatsapp: data.whatsapp || '',
  //       client_name: data.client_name || 'ATENDIMENTO BALCÃO',
  //       payment_method_id: data.payment,
  //       delivery_type: deliveryType,
  //       products: JSON.stringify(parseProducts),
  //       order_payments: JSON.stringify(orderPayments),
  //     } as any;

  //     if (discountPercentage > 0 && discountValue > 0) {
  //       parseData = {
  //         ...parseData,
  //         single_discount_percentual: discountPercentage,
  //         single_discount_value: discountValue,
  //       };
  //     }

  //     if (paymentIsMoney) {
  //       let money_change = $('#money_change').val() as string;

  //       money_change = money_change.replaceAll('.', '');
  //       money_change = money_change.replaceAll(',', '.');

  //       parseData = {
  //         ...parseData,
  //         money_change: parseFloat(money_change),
  //       };
  //     }

  //     if (deliveryType === 'Delivery') {
  //       parseData = {
  //         ...parseData,
  //         address_road: orderAddress.road,
  //         address_reference: orderAddress.reference,
  //         address_city: orderAddress.city,
  //         address_state: orderAddress.state,
  //         address_postcode: orderAddress.postcode,
  //         address_number: orderAddress.number,
  //         address_neighbourhood: orderAddress.neighbourhood,
  //         address_complement: orderAddress.complement,
  //         distance_id: orderAddress.id,
  //       };
  //     }

  //     await api.post(`pos/${appDomain}/${API_URL_ORDER}`, parseData);

  //     $('#single_discount_percentual').val('');
  //     $('#single_discount_value').val('');
  //     updateDiscount(0, 0);

  //     setShowConfirmOrder(false);

  //     setOrderAddress({} as IAddress);

  //     clear();

  //     setOpenModalCart(false);

  //     $(window).scrollTop(0);

  //     toast('Pedido realizado com sucesso!', {
  //       type: 'success',
  //       theme: 'colored',
  //     });

  //     setLoading(false);
  //   } catch (err) {
  //     setLoading(false);
  //     console.log(err);
  //   }
  // }, [
  //   data,
  //   products,
  //   clear,
  //   setShowConfirmOrder,
  //   setOpenModalCart,
  //   deliveryType,
  //   setOrderAddress,
  //   appDomain,
  //   orderAddress,
  //   paymentIsMoney,
  //   orderPayments,
  //   discountPercentage,
  //   discountValue,
  //   updateDiscount,
  // ]);

  const removeOrderPayment = useCallback(
    (index: number) => {
      const tmp = [...orderPayments];
      tmp.splice(index, 1);
      setOrderPayments(tmp);
    },
    [orderPayments],
  );

  // const addOrderPayment = useCallback(() => {
  //   if (payments.length === 0) return;

  //   let sum = 0;
  //   orderPayments.forEach(item => (sum += item.value));

  //   const tmp = [...orderPayments];

  //   const value = total - sum;
  //   const value_formatted = Number(value).toLocaleString('pt-br', {
  //     style: 'currency',
  //     currency: 'BRL',
  //   });

  //   tmp.push({
  //     payment_method_id: payments[0].id,
  //     value,
  //     value_formatted,
  //   });

  //   setOrderPayments(tmp);

  //   setTimeout(() => {
  //     ($('.money') as any).mask('#.##0,00', { reverse: true });
  //   }, 10);
  // }, [orderPayments, total, payments]);

  useEffect(() => {
    ($('.phone') as any).mask('(00) 00000-0000');
    ($('.money') as any).mask('#.##0,00', { reverse: true });
  }, [payment]);

  // useEffect(() => {
  //   if (payments.length > 0) {
  //     const value_formatted = Number(total).toLocaleString('pt-br', {
  //       style: 'currency',
  //       currency: 'BRL',
  //     });

  //     setOrderPayments([
  //       {
  //         payment_method_id: payments[0].id,
  //         value: total,
  //         value_formatted,
  //       },
  //     ]);
  //   }
  // }, [payments, total]);

  useEffect(() => {
    setTimeout(() => {
      ($('.money') as any).mask('#.##0,00', { reverse: true });
    }, 100);
  }, []);

  return (
    <>
      <Container>
        <div>
          <Header>
            <h3>POS Tem Pedido</h3>
            <div
              style={{ cursor: 'pointer' }}
              className="toggle btn btn-icon p-2 btn-secundary"
              onClick={() => setShowConfirmOrder(false)}
            >
              <i className="fa fa-times" style={{ fontSize: 18 }} />
            </div>
          </Header>

          {fidelitAlert.value && (
            <div className="alert alert-warning alert-icon alert-dismissible">
              <em className="icon ni ni-alert-circle" />
              {fidelitAlert.message}
            </div>
          )}

          <SubHeader>
            <p>ATENDIMENTO BALCÃO</p>
            <p>{datetime}</p>
          </SubHeader>

          <TableContainer>
            <Table>
              <tr>
                <th>#</th>
                <th>Item</th>
                <th>Qtd</th>
                <th>Total</th>
              </tr>
              {products.map((item, index) => (
                <tr key={`tr-${item.uid}`}>
                  <td>{index + 1}</td>
                  <td>{item.name}</td>
                  <td>{`${item.quantity}x`}</td>
                  <td>
                    {Number(item.value).toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </td>
                </tr>
              ))}
            </Table>
          </TableContainer>

          <Resume>
            {!orderAddressText && (
              <div className="mb-3">
                <AddressText>{getAddressFormatted(orderAddress)}</AddressText>
                <AddressButton onClick={alterAddress}>
                  Alterar Endereço
                </AddressButton>
              </div>
            )}

            {orderAddressText && (
              <div className="mb-3">
                <AddressText>
                  <b>Endereço</b>
                  <p style={{ fontSize: 14 }}>{orderAddressText}</p>
                </AddressText>
                <AddressButton onClick={alterAddress}>
                  Alterar Endereço
                </AddressButton>
              </div>
            )}

            {/* {moneyChange > 0 && (
              <div>
                <h3>Troco</h3>
                <p>
                  {moneyChange.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
                </p>
              </div>
            )} */}

            <div>
              <h3>Subtotal</h3>
              <p>
                {subtotal.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </p>
            </div>
            <div>
              <h3 className="text-danger">Acréscimo</h3>
              <p className="text-danger">
                {additionValue.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </p>
            </div>
            {addCardValue > 0 && (
              <div>
                <h3 className="text-danger">Acréscimo Cartão de Crédito</h3>
                <p className="text-danger">
                  {addCardValue.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
                </p>
              </div>
            )}
            <div>
              <h3 className="text-warning">Desconto</h3>
              <p className="text-warning">
                {discountValue.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </p>
            </div>

            {fidelitDiscount > 0 && (
              <div>
                <h3 className="text-warning">Desconto Fidelidade</h3>
                <p className="text-warning">
                  {fidelitDiscount.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
                </p>
              </div>
            )}

            {orderAddress.distance && (
              <div>
                <h3>Taxa de entrega</h3>
                <p>
                  {orderAddress.distance.value.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
                </p>
              </div>
            )}
            <div className="mb-3">
              <h3>Total</h3>
              <p>
                {(total + addCardValue).toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </p>
            </div>

            <InputContainer>
              <input
                type="text"
                placeholder="Nome do cliente"
                defaultValue={data.name}
                onChange={event => {
                  setData({
                    ...data,
                    name: event.target.value,
                  });
                }}
              />
            </InputContainer>

            <InputContainer>
              <input
                type="text"
                className="phone"
                placeholder="Contato do cliente"
                defaultValue={data.whatsapp}
                onChange={event => {
                  setData({
                    ...data,
                    whatsapp: event.target.value,
                  });
                }}
              />
            </InputContainer>

            <SelectContainer>
              <SelectDeliveryman
                onSelect={(id: string) => {
                  setDeliverymanId(id);
                }}
                value={deliverymanId}
              />
            </SelectContainer>

            {/* <p className="m-0" style={{ color: '#394365', fontSize: 12 }}>
              Forma de Pagamento
            </p>
            <SelectContainer>
              <select
                value={payment}
                onChange={event => setPayment(event.target.value)}
              >
                <option value="">Selecione...</option>
                <option value="0">Dinheiro</option>
                <option value="1">Débito</option>
                <option value="2">Crédito</option>
                <option value="3">PIX</option>
                {company.sell_on_credit === '1' && (
                  <option value="4">Fiado</option>
                )}
              </select>
            </SelectContainer> */}

            <Payments className="mt-3">
              <div className="w-100">
                <label htmlFor="">Valor</label>
              </div>
              <div className="w-100">
                <label htmlFor="">Forma de pagamento</label>
              </div>
              <div style={{ minWidth: 42 }} />
            </Payments>

            {orderPayments.map((paymentItem, index) => (
              <Payments key={`order-payment-${index}`}>
                <div className="w-100">
                  <InputContainer>
                    <input
                      id={`payment-value-${index}`}
                      type="text"
                      className="money"
                      placeholder="R$ 0,00"
                      defaultValue={paymentItem.value_formatted}
                      onKeyUp={() => {
                        const { value } = document.getElementById(
                          `payment-value-${index}`,
                        ) as any;

                        let parseValue = '0';

                        if (value) {
                          parseValue = value.replaceAll('.', '');
                          parseValue = parseValue.replaceAll(',', '.');
                        }

                        const tmp = [...orderPayments];
                        tmp[index].value = parseFloat(parseValue);
                        tmp[index].value_formatted = getCurrencyFormatted(
                          parseFloat(parseValue),
                        );

                        setOrderPayments(tmp);
                      }}
                    />
                  </InputContainer>
                </div>
                <div className="w-100 ml-2 mr-2">
                  <SelectContainer className="w-100">
                    <select
                      id="payment"
                      defaultValue={orderPayments[index].payment_method_id}
                      onChange={event => {
                        const paymentType = event.target.value;

                        const { value } = document.getElementById(
                          `payment-value-${index}`,
                        ) as any;

                        let parseValue = '0';

                        if (value) {
                          parseValue = value.replaceAll('.', '');
                          parseValue = parseValue.replaceAll(',', '.');
                        }

                        let addValueCardItem = 0;
                        const valueRef = parseFloat(parseValue);

                        if (
                          paymentType === '2' &&
                          company.add_card_type === '1'
                        ) {
                          const addCard = (valueRef * company.add_card) / 100;
                          addValueCardItem += addCard;
                        }

                        if (
                          paymentType === '2' &&
                          company.add_card_type !== '1' &&
                          company.add_card > 0
                        ) {
                          addValueCardItem += company.add_card;
                        }

                        const tmp = [...orderPayments];
                        tmp[index].payment_method_id = event.target.value;

                        tmp[index].value2 = valueRef + addValueCardItem;

                        tmp[index].value_formatted = getCurrencyFormatted(
                          valueRef + addValueCardItem,
                        );

                        setOrderPayments(tmp);
                      }}
                    >
                      <option value="">Selecione...</option>
                      <option value="0">Dinheiro</option>
                      <option value="1">Débito</option>
                      <option value="2">Crédito</option>
                      <option value="3">PIX</option>
                      {company.sell_on_credit === '1' && (
                        <option value="4">Fiado</option>
                      )}
                      <option value="5">IFood</option>
                    </select>
                  </SelectContainer>
                </div>

                {index === 0 && (
                  <button type="button" onClick={addNewPaymentMethod}>
                    <em className="icon ni ni-plus" />
                  </button>
                )}

                {index > 0 && (
                  <button
                    type="button"
                    onClick={() => removeOrderPayment(index)}
                  >
                    <i className="fa fa-trash" />
                  </button>
                )}
              </Payments>
            ))}

            {error.paymentMethod && (
              <p className="text-danger" style={{ fontSize: 12 }}>
                * Por favor, selecione a forma de pagamento.
              </p>
            )}

            {paymentIsMoney && (
              <div className="d-flex flex-column align-items-start justify-content-start">
                <p className="m-0" style={{ color: '#394365', fontSize: 12 }}>
                  Troco para?
                </p>
                <InputContainer>
                  <input
                    id="money_change"
                    type="text"
                    className="money"
                    placeholder="R$ 0,00"
                    onKeyUp={() => {
                      const { value } = document.getElementById(
                        'money_change',
                      ) as any;

                      let parseValue = '0';

                      if (value) {
                        parseValue = value.replaceAll('.', '');
                        parseValue = parseValue.replaceAll(',', '.');
                      }

                      setData({
                        ...data,
                        money_change: `${parseFloat(parseValue)}`,
                      });
                    }}
                  />
                </InputContainer>
              </div>
            )}

            {paymentIsSellCredit && (
              <div className="d-flex flex-column align-items-start justify-content-start">
                <p className="m-0" style={{ color: '#394365', fontSize: 12 }}>
                  Data do pagamento?
                </p>
                <InputContainer>
                  <input
                    type="date"
                    placeholder="dd/mm/yyyy"
                    onChange={event => {
                      setData({
                        ...data,
                        sell_on_credit_date: event.target.value,
                      });
                    }}
                  />
                </InputContainer>
                {error.sell_on_credit_date && (
                  <p className="text-danger" style={{ fontSize: 12 }}>
                    * Campo obrigatório
                  </p>
                )}
              </div>
            )}

            {errors && <Error>{errors}</Error>}

            {/* {paymentIsMoney && (
              <div className="d-flex flex-column align-items-start justify-content-start">
                <p
                  className="text-nowrap mr-2"
                  style={{ color: '#696969', fontWeight: 'normal' }}
                >
                  Troco para?
                </p>
                <InputContainer>
                  <input
                    id="money_change"
                    type="text"
                    className="money"
                    placeholder="R$ 0,00"
                    onKeyUp={() => {
                      const { value } = document.getElementById(
                        'money_change',
                      ) as any;

                      let parseValue = '0';

                      if (value) {
                        parseValue = value.replaceAll('.', '');
                        parseValue = parseValue.replaceAll(',', '.');
                      }

                      setData({
                        ...data,
                        money_change: `${parseFloat(parseValue)}`,
                      });
                    }}
                  />
                </InputContainer>
              </div>
            )} */}

            <button type="button" onClick={handleSubmit}>
              {loading && (
                <div className="d-flex justify-content-center">
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden" />
                  </div>
                </div>
              )}
              {!loading &&
                `FINALIZAR ${(total + addCardValue).toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                })}`}
            </button>
          </Resume>
        </div>
      </Container>
      <Overlay onClick={() => setShowConfirmOrder(false)} />
    </>
  );
};

export default OrderConfirm;
